import React, { useRef, useState } from "react";

import styled from "styled-components/macro";

import FnrButton, { ButtonIcon, ButtonText } from "UI/FnrButton3";
import FnrConfirmationPopover from "UI/FnrConfirmationPopover";

import API from "../../API";
import { useRecurringGifts } from "../../RecurringGiftsContext";

export default function DeleteButton({ closeModal }) {
  const { state, dispatch } = useRecurringGifts();
  const { ID, paymentType } = state.editModal.currentGift;
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [status, setStatus] = useState(null);
  const triggerRef = useRef();

  const paymentNoun = paymentType?.toLowerCase() || "payment";

  const handleCancelClick = () => {
    setShowConfirmation(false);
    setStatus(null);
  };

  const handleConfirmClick = () => {
    setStatus("loading");

    API.delete({ ID })
      .post()
      .then((res) => {
        dispatch({
          type: "handleGetRecurringGiftsResponse",
          payload: res,
        });
        setShowConfirmation(false);
        setStatus(null);
        closeModal();
      })
      .catch((err) => {
        setStatus("error");
      });
  };

  const confirmationContent = () => {
    return (
      <ConfirmContent>
        {status === "error" ? (
          <Error>
            Oh no! A problem occurred. Please refresh and try again, or contact
            help@flocknote.com for assistance.
          </Error>
        ) : null}
        <ConfirmLine1>
          Are you sure you want to delete this recurring {paymentNoun}?
        </ConfirmLine1>
      </ConfirmContent>
    );
  };

  return (
    <Wrapper>
      <FnrButton
        data-cy="deleteRecurringBtn"
        ref={triggerRef}
        size="small"
        fullWidth
        disabled={status === "loading"}
        onClick={() => setShowConfirmation((prev) => !prev)}
      >
        <ButtonIcon fas fa-trash />
        <ButtonText>Delete</ButtonText>
      </FnrButton>

      <FnrConfirmationPopover
        show={showConfirmation}
        ref={triggerRef}
        onClose={() => setShowConfirmation(false)}
        message={confirmationContent()}
        button1={
          <FnrButton
            data-cy="recurringDeleteCancelBtn"
            text={`Cancel`}
            onClick={handleCancelClick}
            disabled={status === "loading"}
          />
        }
        button2={
          <FnrButton
            data-cy="recurringDeleteConfirmBtn"
            text={`Delete`}
            onClick={handleConfirmClick}
            color="red"
            loading={status === "loading"}
          />
        }
        style={{ maxWidth: 280, padding: 20 }}
      />
    </Wrapper>
  );
}

const Wrapper = styled.div``;

const ConfirmContent = styled.div`
  line-height: 1.4;
  margin-bottom: 20px;
`;

const ConfirmLine1 = styled.div``;

const Error = styled.div`
  background-color: #f7f0b6;
  line-height: 1.2;
  font-size: 14px;
  color: #ad8114;
  font-weight: 400;
  padding: 10px 14px;
  border-radius: 7px;
  margin-bottom: 10px;
`;
